module.exports = __webpack_public_path__ + "img/2610-1.898fc457.png";